import { useState, useEffect } from 'react';
import { getNumberOfUsers } from "../../../APIs/auditor_dashboard";

const useNumberOfUsers = (filters, setLoading) => {
    const [data, setData] = useState(0);

    const fetchNumberOfUsers = async () => {
        try {
            setLoading(true);
            const response = await getNumberOfUsers(filters);
            setData(response.data.count);
        } catch (error) {
            console.error('Error fetching number of users:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNumberOfUsers();
    }, [filters]);

    return data;
};

export default useNumberOfUsers;
